import React from 'react';
import '@/App.css';
import '@/styles/landing.css';
import '@/styles/mobile-fixes.css';
import '@/styles/content-protection.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LandingPage from '@/pages/LandingPage';
import Impressum from '@/pages/Impressum';
import Datenschutz from '@/pages/Datenschutz';
import { Toaster } from '@/components/ui/sonner';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;

